import React from "react";
import B2BProtectedRoute from "../components/B2B/B2BShared/B2BProtectedRoute/B2BProtectedRoute";
import B2BLoginForm from "../components/B2B/B2BAuth/B2BLoginForm/B2BLoginForm.tsx";
import B2BRegisterForm from "../components/B2B/B2BAuth/B2BRegisterForm/B2BRegisterForm.tsx";
import B2BForgotPassword from "../components/B2B/B2BAuth/B2BForgotPassword/B2BForgotPassword";
import B2BResetPassword from "../components/B2B/B2BAuth/B2BResetPassword/B2BResetPassword";
import B2BDashboard from "../components/B2B/B2BDashboard/B2BDashboard.tsx";
import B2BDashboardEvents from "../components/B2B/B2BDashboard/B2BDashboardEvents/B2BDashboardEvents";
import B2BDashboardPayments from "../components/B2B/B2BDashboard/B2BDashboardPayments/B2BDashboardPayments";
import B2BDashboardBrandPerception from "../components/B2B/B2BDashboard/B2BDashboardBrandPerception/B2BDashboardBrandPerception";
import B2BProfile from "../components/B2B/B2BProfile/B2BProfile";
import B2BProfileCreate from "../components/B2B/B2BProfile/B2BProfileCreate/B2BProfileCreate.tsx";
import B2BParticipantsList from "../components/B2B/B2BParticipantsList/B2BParticipantsList";
import B2BEvents from "../components/B2B/B2BEvents/B2BEvents";
import B2BWaitingApproval from "../components/B2B/B2BAuth/B2BWaitingApproval/B2BWaitingApproval";
import B2BEmailVerification from "../components/B2B/B2BAuth/B2BEmailVerification/B2BEmailVerification.tsx";
import B2BEmailConfirm from "../components/B2B/B2BAuth/B2BEmailConfirm/B2BEmailConfirm";
import B2BAdminProfileView from "../components/B2B/B2BAdmin/B2BAdminProfileView/B2BAdminProfileView";
import B2BApprovalSuccess from "../components/B2B/B2BAdmin/B2BApprovalSuccess/B2BApprovalSuccess";
import B2BApprovalError from "../components/B2B/B2BAdmin/B2BApprovalError/B2BApprovalError";
import B2BTermsPage from "../components/B2B/B2BTerms/B2BTermsPage";
import B2BPrivacyPage from "../components/B2B/B2BPrivacy/B2BPrivacyPage";
import B2BAutoLogin from "../components/B2B/B2BAuth/B2BAutoLogin/B2BAutoLogin";
import B2BToGcbRedirect from "./B2BToGcbRedirect";

/**
 * B2B routes configuration
 * Routes for B2B functionality including authentication and protected routes
 */
// Legacy alias routes: redirect /b2b/* -> /gcb/*
export const b2bRoutes = [
  {
    path: "/b2b/*",
    element: <B2BToGcbRedirect />,
    public: true,
  },
];

// Canonical routes: /gcb/*
export const gcbRoutes = [
  // Authentication Routes (Public)
  {
    path: "/gcb/login",
    element: <B2BLoginForm />,
    public: true,
  },
  {
    path: "/gcb/register",
    element: <B2BRegisterForm />,
    public: true,
  },
  {
    path: "/gcb/forgot-password",
    element: <B2BForgotPassword />,
    public: true,
  },
  {
    path: "/gcb/reset-password",
    element: <B2BResetPassword />,
    public: true,
  },
  {
    path: "/gcb/waiting-approval",
    element: <B2BWaitingApproval />,
    public: true,
  },
  {
    path: "/gcb/email-verification",
    element: <B2BEmailVerification />,
    public: true,
  },
  {
    path: "/gcb/verify-email",
    element: <B2BEmailVerification />,
    public: true,
  },
  {
    path: "/gcb/verify-email/:token",
    element: <B2BEmailConfirm />,
    public: true,
  },
  {
    path: "/gcb/terms",
    element: <B2BTermsPage />,
    public: true,
  },
  {
    path: "/gcb/privacy",
    element: <B2BPrivacyPage />,
    public: true,
  },
  {
    path: "/gcb/auto-login",
    element: <B2BAutoLogin />,
    public: true,
  },
  {
    path: "/gcb/admin/approval-success",
    element: <B2BApprovalSuccess />,
    public: true,
  },
  {
    path: "/gcb/admin/approval-error",
    element: <B2BApprovalError />,
    public: true,
  },

  // Protected Routes
  {
    path: "/gcb/dashboard",
    element: (
      <B2BProtectedRoute>
        <B2BDashboard />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/dashboard/events",
    element: (
      <B2BProtectedRoute>
        <B2BDashboardEvents />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/dashboard/payments",
    element: (
      <B2BProtectedRoute>
        <B2BDashboardPayments />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/dashboard/brand-perception",
    element: (
      <B2BProtectedRoute>
        <B2BDashboardBrandPerception />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/profile",
    element: (
      <B2BProtectedRoute>
        <B2BProfile />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/profile/create",
    element: (
      <B2BProtectedRoute>
        <B2BProfileCreate />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/profile/edit",
    element: (
      <B2BProtectedRoute>
        <B2BProfileCreate />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/participants",
    element: (
      <B2BProtectedRoute>
        <B2BParticipantsList />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/events",
    element: (
      <B2BProtectedRoute>
        <B2BEvents />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
  {
    path: "/gcb/admin/profile/:userId",
    element: (
      <B2BProtectedRoute requireAdmin={true}>
        <B2BAdminProfileView />
      </B2BProtectedRoute>
    ),
    protected: true,
  },
];
